import HfReactHelper from 'js/sign-components/common/hf-react-helper';

let CSRFToken: string;

export function setCsrfToken(csrfToken: string) {
  CSRFToken = csrfToken;
}
export function getCSRFToken(): string {
  return CSRFToken;
}

export function updateSessionTimeout() {
  // @ts-ignore sessionTimeoutMonitor
  const sessionTimeoutMonitor = window.SessionTimeoutMonitor;
  // @ts-ignore hellofaxJS is a global
  const hellofaxJS = window.hellofaxJS;
  if (sessionTimeoutMonitor && hellofaxJS) {
    hellofaxJS.setLastAjaxTimestamp(sessionTimeoutMonitor.getNow());
  }
}

export function needsCSRFToken(url: string) {
  return new URL(url, window.location.href).host === new URL('/', window.location.href).host;
}

/* eslint-disable no-restricted-globals */
export default function hsFetch(url: string, options: RequestInit = {}): ReturnType<typeof fetch> {
  // If this is running in an iframe on another site, the browser may choose to
  // not include the "3rd party" cookies. This attaches the session info so the
  // session isn't lost.
  if (window.top !== window) {
    // eslint-disable-next-line no-param-reassign
    url = HfReactHelper.attachSessionInfoToUrl(url);
  }

  const requestHeaders: HeadersInit = {
    Accept: 'application/json',
    ...options.headers,
  };

  if (needsCSRFToken(url)) {
    // Adding global X-CSRF-Token
    (requestHeaders as any)['X-CSRF-Token'] = CSRFToken;
  }

  const requestOptions = {
    ...options,
  };

  requestOptions.headers = requestHeaders;

  return fetch(url, {
    credentials: 'same-origin',
    method: 'GET',
    ...requestOptions,
  });
}
